import { ManageApis } from "../APIS/ManageApis";
import { getLocalStorage, handleApiError } from "../Utils/Utils";

export const fetchCreditDetails = async (setCreditData, showAlert) => {
  const token = getLocalStorage("token");
  try {
    const response = await ManageApis("get", window.creditUsage, "", token);
    const { status_code, message } = response || {};
    const {
      status,
      message: responseMessage = "",
      data,
    } = response?.response_data || {};

    if (status_code === 200 && message === "Success") {
      if (status === "Success") {
        setCreditData(data);
      } else {
        handleApiError(status, responseMessage, status_code, showAlert);
      }
    } else {
      handleApiError(status, message, status_code, showAlert);
    }
  } catch (error) {
    console.error("Error fetching credit details:", error);
  }
};
